export function formatWithPereod(num: number): string {
  const rounded = num.toFixed(1);

  return rounded.replace('.', ',');
}

export function formatNumberWithSpace(num: number): string {
  const rounded = Number.isFinite(num) ? Math.round(num) : 0;

  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
